import { useDispatch } from "react-redux";
import axios from "axios";
import { Table, Button, Icon, Modal, Label, List, Dimmer, Loader } from "semantic-ui-react";
import { useSelector } from "react-redux";
import { addProjectChecklist, setProject, resetProject, setPartners, setLeadPartner, setMarkers,setLastPaymentDate } from "../../redux/projectSlice";
import { loadingEnd, loadingStart, resetError, setError, setPage, showMenuPDF } from "../../redux/appSlice";

const Project = (props) => {
    const dispatch = useDispatch();
    const app = useSelector(state => state.app);
    const project = useSelector(state => state.project.project);
    const projectState = useSelector(state => state.project);
    const API_URL = process.env.REACT_APP_BASE_API_URL;
    const options = {
        headers: { 'Content-Type': 'application/json' },
        withCredentials: true
    }

    const projectPartnersToMarkers = async () => {
        dispatch(loadingStart());
        const api = process.env.REACT_APP_BASE_API_URL_MDB;
        let partners = [...projectState.partners];
        const capCallPartners = Array.isArray(project.capCallPartners) ? [...project.capCallPartners] : [];
        partners.sort((a, b) => a.sortNumber > b.sortNumber ? -1 : 1);

        // IDs des partners référencés dans le capCall
        const capCallPartnerIds = new Set(capCallPartners.filter(p => p.id != null).map(p => p.id));
        const leadPartnerId = partners.find(p => p.role === 'LEAD_PARTNER')?.id;
        if (partners.some(partner => partner.detail?.addresses.length === 0)){
            dispatch(loadingEnd());
            dispatch(setError('Geographical Statement cannot be generated, there is at least one partner without an address'));
            dispatch(showMenuPDF(false))
        }else{
            let geoJson = { type: "FeatureCollection", features: [] };
            const validCapCallPartners = capCallPartners.filter(partner => partner.organizationAddress?.countryCode && partner.organizationAddress?.city);
            const markersCapCall = validCapCallPartners.length > 0
                ? await Promise.all(validCapCallPartners.map(partner => axios.get(`${api}/geopositions?city=${partner.organizationAddress.city.replace(/cedex/i, '').replace(/\(/, '').replace(/\)/, '').replace(/ or /, ' ')}&countryCode=${partner.organizationAddress.countryCode}&postalCode=${partner.organizationAddress.postalCode}`)
                    .then(response => {
                        return ({ type: "Feature", geometry: { type: "Point", coordinates: [response.data.lng, response.data.lat] }, properties: { name: "", color: partner.id ? '#9b59b6' : '#f1c232', isLeadPartner: partner.id === leadPartnerId } });
                    })
                ))
                : [];

            const filteredPartners = partners.filter(partner => !capCallPartnerIds.has(partner.id) && partner.active === true);
            const markers = await Promise.all(filteredPartners.map(partner => axios.get(`${api}/geopositions?city=${partner.detail?.addresses?.[0].city.replace(/cedex/i, '').replace(/\(/, '').replace(/\)/, '').replace(/ or /, ' ')}&countryCode=${partner.detail?.addresses?.[0].countryCode}&postalCode=${partner.detail?.addresses?.[0].postalCode}`)
                .then(response => {
                    return ({ type: "Feature", geometry: { type: "Point", coordinates: [response.data.lng, response.data.lat] }, properties: { name: "", color: partner.role === 'LEAD_PARTNER' ? '#f57a49' : '#609bc4' } });
                })
            ));

            geoJson.features = [...markersCapCall, ...markers];
            dispatch(setMarkers(geoJson));
            dispatch(loadingEnd());
            dispatch(setPage('Cartographie'));
        }
    }

    const getProjectSteps = () => {

        if (project.callSettings?.endDateStep1 === null) {
            return (
                <List divided relaxed>
                    <List.Item>
                        <List.Content>
                            <Label color='red' ribbon>PDF</Label>
                            <List.Header as='a' onClick={() => dispatch(setPage('DetailOneStep'))}>Assessment report</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Dimmer active={app.loading}>
                            <Loader>Please wait, we're preparing the map</Loader>
                        </Dimmer>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => projectPartnersToMarkers()}>Geographical Statement</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => dispatch(setPage('NotificationLetterStep2'))}>Notification Letter</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => dispatch(setPage('SubsidyContract'))}>Subsidy Contract</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => dispatch(setPage('SubsidyContractCover'))}>Cover Letter for Subsidy Contract</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => dispatch(setPage('Closure'))}>Closure letter</List.Header>
                        </List.Content>
                    </List.Item>
                </List>

            )
        } else {
            return (
                <List divided relaxed>
                    <List.Item>
                        <List.Content>
                            <Label color='red' ribbon>PDF</Label>
                            <List.Header as='a' onClick={() => dispatch(setPage('DetailStep1'))}>Step 1 Assessment report</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => dispatch(setPage('DetailStep2'))}>Step 2 Assessment report</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => dispatch(setPage('CapCallAssessment'))}>Capitalisation Assessment report</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => dispatch(setPage('NotificationLetterCapCallApproval'))}>Capitalisation Approval Letter</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => dispatch(setPage('NotificationLetterCapCallRejection'))}>Capitalisation Rejection Letter</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Dimmer active={app.loading}>
                            <Loader>Please wait, we're preparing the map</Loader>
                        </Dimmer>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => projectPartnersToMarkers()}>Geographical Statement</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => dispatch(setPage('NotificationLetterStep1'))}>Step 1 Notification Letter</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => dispatch(setPage('NotificationLetterStep2'))}>Step 2 Notification Letter</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => dispatch(setPage('SubsidyContract'))}>Subsidy Contract</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => dispatch(setPage('SubsidyContractCover'))}>Cover Letter for Subsidy Contract</List.Header>
                        </List.Content>
                    </List.Item>
                    <List.Item>
                        <Label color='red' ribbon>PDF</Label>
                        <List.Content>
                            <List.Header as='a' onClick={() => dispatch(setPage('Closure'))}>Closure letter</List.Header>
                        </List.Content>
                    </List.Item>
                </List>
            )
        }
    }
    const getProjectDetail = async () => {
        dispatch(resetError());
        dispatch(loadingEnd());
        try {
            dispatch(resetProject());
            const promiseProject = axios.get(API_URL + '/project/byId/' + props.project.id, options).then((response) => {
                return axios.get(API_URL + '/project/byId/' + props.project.id + '/form', options).then((resForm) => {
                    return { ...response.data, duration: resForm.data.duration };
                });
            });

            const promiseChecklists = axios.get(API_URL + '/checklist/instance/' + props.project.id + '/APPLICATION_FORM_ASSESSMENT/', options).then((response) => response.data);
            const promiseCofinancing = axios.get(API_URL + '/project/' + props.project.id + '/coFinancingOverview', options).then((response) => response.data);
            const promisePartners = axios.get(API_URL + '/project/partner/byProjectId/' + props.project.id + '/ids?sort=sortNumber', options).then((response) => response.data);
            const promisepayments = axios.get(API_URL + '/project/payments/' + props.project.id, options).then((response) => response.data);
            const promiseCapCall = axios.get(API_URL + '/project/cap-call?projectId=' + props.project.id, options).then((response) => response.data);
            const promiseProjectReport = axios.get(API_URL + '/project/report/byProjectId/' + props.project.id, options).then((response) => response.data);
            const promiseContract = axios.get(API_URL + '/project/' + props.project.id + '/contracting/contract', options).then((response) => response.data);
            const [project, checklists, cofinancing, partners, payments, capCallData, projectReport, contract] = await Promise.all([promiseProject, promiseChecklists, promiseCofinancing, promisePartners, promisepayments, promiseCapCall, promiseProjectReport, promiseContract]);
            const checklistDetails = await Promise.all(checklists.map(checklist =>
                axios.get(API_URL + '/checklist/instance/' + project.id + '/detail/' + checklist.id, options)
                    .then(response => {
                        return { ...checklist, detail: response.data };
                    })
            ));

            const partnerDetails = await Promise.all(partners.map(partner =>
                axios.get(API_URL + '/project/partner/' + partner.id, options)
                    .then(response => {
                        const address = response.data.addresses.filter(address => address.type === 'Organization');
                        let detail = response.data;
                        detail.addresses = address;
                        return { ...partner, detail: detail };
                    })
            ));

            const lastSubmittedProjectReport = projectReport.content.filter(report => report.status !== 'Draft').sort((a, b) => new Date(b.reportNumber) - new Date(a.reportNumber))[0];
            project.lastSubmittedProjectReport = lastSubmittedProjectReport;
            const projectFinancialOverview = await axios.get(API_URL + '/project/report/byProjectId/' + props.project.id + '/financialOverview/byReportId/' + lastSubmittedProjectReport.id + '/coFinancing', options).then(response => response.data);

            checklistDetails.forEach(checklist => dispatch(addProjectChecklist(checklist)));
            partnerDetails.forEach(partner => {
                if (partner.role === 'LEAD_PARTNER') {
                    const leadPartner = partner.detail
                    dispatch(setLeadPartner(leadPartner));
                }
            });

            const paymentsList =  payments.content;
   
            const lastPaymentDate = paymentsList.length > 0 
                ? new Date(Math.max(...paymentsList.map(d => new Date(d.dateOfLastPayment).getTime()))).toISOString()
                : null;

            project.coFinancing = cofinancing;
            project.projectReports = projectReport.content;
            project.contract = contract;
            project.financialOverview = projectFinancialOverview;
            const capCallPartnership = typeof capCallData.capPartnerShip === 'string' ? JSON.parse(capCallData.capPartnerShip) : capCallData.capPartnerShip;
            const capCallDescription = typeof capCallData.capInitiativeDescription === 'string' ? JSON.parse(capCallData.capInitiativeDescription) : capCallData.capInitiativeDescription;
            console.warn('Cap Call Data : ', capCallData);
            if (capCallPartnership && capCallDescription) {
                project.capCallPartners = capCallPartnership.partners.filter(partner => partner.motivation.roleInCapitalisationInitiative != null);
                project.capCallDuration = capCallDescription.duration
                console.warn('Project with cap call duration : ', project.capCallDuration);

                const costCategories = ['staffCosts', 'travelCosts', 'externalCosts', 'equipmentCosts', 'infrastructureCosts'];

                const calculateFlatRates = (partner) => {
                    if (!partner.budgets) return 0;
                    const staffCosts = (partner.budgets.staffCosts || []).filter(item => item.id === null).reduce((s, item) => s + item.rowSum, 0);
                    const opts = partner.budgetOptions || {};
                    if (opts.otherCostsOnStaffCostsFlatRate != null) {
                        return staffCosts * opts.otherCostsOnStaffCostsFlatRate / 100;
                    }
                    const travelRate = opts.travelAndAccommodationOnStaffCostsFlatRate || 0;
                    const officeRate = opts.officeAndAdministrationOnStaffCostsFlatRate || 0;
                    return staffCosts * travelRate / 100 + staffCosts * officeRate / 100;
                };

                const capCallBudgetTEC = project.capCallPartners.reduce((total, partner) => {
                    if (!partner.budgets) return total;
                    const itemCosts = costCategories.reduce((sum, category) =>
                        sum + (partner.budgets[category] || []).filter(item => item.id === null).reduce((s, item) => s + item.rowSum, 0), 0);
                    const flatRateCosts = calculateFlatRates(partner);
                    // console.warn(`Partner ${partner.id} - New expenses: ${itemCosts}, Flat rates: ${flatRateCosts}`);
                    return Math.round((total + itemCosts + flatRateCosts) * 100) / 100;
                }, 0);
                const capCallBudgetERDF = project.capCallPartners.reduce((total, partner) => {
                    if (!partner.budgets || !partner.coFinancing) return total;
                    const itemCosts = costCategories.reduce((sum, category) =>
                        sum + (partner.budgets[category] || []).filter(item => item.id === null).reduce((s, item) => s + item.rowSum, 0), 0);
                    const flatRateCosts = calculateFlatRates(partner);
                    const partnerTotal = itemCosts + flatRateCosts;
                    // console.warn(`Partner ${partner.id} - New expenses total (ERDF): ${Math.floor(partnerTotal * partner.coFinancing.erdfPercentage) / 100}`);
                    return total + Math.floor(partnerTotal * partner.coFinancing.erdfPercentage) / 100;
                }, 0);
                project.capCallBudgetTEC = capCallBudgetTEC;
                project.capCallBudgetERDF = capCallBudgetERDF;
            }
            dispatch(setPartners(partnerDetails));
            dispatch(setProject(project));
            dispatch(setLastPaymentDate(lastPaymentDate));
            dispatch(showMenuPDF(true));
        } catch (error) {
            console.error('There was an error fetching the project details:', error);
            dispatch(setError(error.code));
        }
    }

    return (

        <Table.Row key={props.project.id}>
            <Table.Cell>{props.project.customIdentifier}</Table.Cell>
            <Table.Cell>{props.project.acronym}</Table.Cell>
            <Table.Cell>{props.project.projectStatus}</Table.Cell>
            <Table.Cell>{props.project.specificObjectiveCode}</Table.Cell>
            <Table.Cell>{props.project.programmePriorityCode}</Table.Cell>
            <Table.Cell>

                <Modal
                    onClose={() => dispatch(showMenuPDF(false))}
                    onOpen={() => dispatch(showMenuPDF(true))}
                    open={app.menuPDFVisible}
                    size='mini'
                >
                    <Modal.Header>{project.customIdentifier}</Modal.Header>
                    <Modal.Content>
                        <Modal.Description>
                            Please select a report to generate
                        </Modal.Description>
                        {getProjectSteps()}
                    </Modal.Content>
                    <Modal.Actions>
                        <Button color='black' onClick={() => dispatch(showMenuPDF(false))}>
                            Cancel
                        </Button>
                    </Modal.Actions>
                </Modal>
                <Button icon onClick={getProjectDetail}><Icon name='plus square outline' /></Button>
            </Table.Cell>
        </Table.Row>
    )
}

export default Project;